import Button from '../../../../components/Button';
import StickyPanel from '../../../../components/StickyPanel';
import { t } from '../../../../lang';
import { createRootModal } from '../../RootModal';
import './LearnAboutAmlRiskModal.scss';

const LearnAboutAmlRiskModal = createRootModal(({ handleClose }) => {
	return (
		<div className='LearnAboutAmlRiskModal'>
			<StickyPanel
				controls={
					<Button onClick={handleClose} styleType='white'>
						{t('Got it')}
					</Button>
				}
			>
				<div className='LearnAboutAmlRiskModal_content'>
					<div className='LearnAboutAmlRiskModal_content_text'>
						<p className='LearnAboutAmlRiskModal_content_regular'>
							{t('AML risk indicates the potential exposure of funds to illicit or high-risk activity.')}
						</p>
					</div>

					<div className='LearnAboutAmlRiskModal_content_text'>
						<p className='LearnAboutAmlRiskModal_content_text_bold'>{t('What does this mean?')}</p>
						<p>
							{t(
								'The risk level is calculated based on transaction history and connections to various sources and counterparties.'
							)}
						</p>
						<p className='LearnAboutAmlRisk_content_text'>
							{t(
								'It helps identify whether funds may be associated with sanctions, fraud, illegal services, or other risky activity.'
							)}
						</p>
					</div>

					<div className='LearnAboutAmlRisk_content_text'>
						<p className='LearnAboutAmlRisk_content_text_bold'>{t('What should you do?')}</p>
						<p>{t('Use AML risk as a reference when interacting with addresses.')}</p>
						<p>{t('Review detailed AML information to better understand the nature and origin of funds.')}</p>
					</div>
				</div>
			</StickyPanel>
		</div>
	);
});

export default LearnAboutAmlRiskModal;
